<div *ngIf="roles$ | async as roles">
  <ng-template #recursiveList let-menuItem>
    <a *ngIf="
      (!menuItem.subPages ||
        !menuItem.subPages.length ||
        !menuItem.hasVisibleSubpages) &&
      !menuItem.hideInNavigation
    " class="dropdown-item p-3 pe-4 cursor-pointer" (click)="navigate($event, menuItem)"
      (auxclick)="navigate($event, menuItem, true)" (mouseenter)="openSubmenu(menuItem)">
      {{ menuItem.label }}
    </a>
    <ng-container *ngIf="
      menuItem.subPages &&
      menuItem.subPages.length &&
      menuItem.hasVisibleSubpages &&
      !menuItem.hideInNavigation
    ">
      <div class="dropdown-submenu" (mouseenter)="openSubmenu(menuItem)">
        <a class="dropdown-item dropdown-toggle p-3 pe-4 cursor-pointer" (click)="navigate($event, menuItem)"
          (auxclick)="navigate($event, menuItem, true)">
          {{ menuItem.label }}
        </a>
        <ul class="dropdown-menu" [ngClass]="{ 'd-block': menuItem.showChildren }" #submenu>
          <ng-container *ngFor="let item of menuItem.subPages; let last = last">
            <li *ngIf="!item.hideInNavigation">
              <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: item }"></ng-container>
            </li>
            <li *ngIf="!last && !item.hideInNavigation">
              <div class="dropdown-divider m-0"></div>
            </li>
          </ng-container>
        </ul>
      </div>
    </ng-container>
  </ng-template>

  <ng-container *ngIf="level != null">
    <div class="dropdown" *ngIf="level.activeMenuItem && level.menuItems.length > 1" ngbDropdown
      #leveldrop="ngbDropdown" (mouseenter)="onHover(true)" (mouseleave)="onHover(false)">
      <button class="btn btn-navigation" [ngStyle]="{'color': getUserColor()}" type="button"
        id="dropdownMenuButton{{ id }}" ngbDropdownAnchor>
        {{ level.activeMenuItem.label }}
      </button>
      <div class="menu-backdrop" *ngIf="!isMobileDevice" [hidden]="!dropdownBackDrop"
        [style.left]="backdropLeft + 'px'">
      </div>
      <div class="dropdown-menu" #dropdownMenu>
        <div class="dropdown-wrapper">
          <ng-container *ngFor="let menuItem of level.menuItems; let last = last">
            <ng-container *ngIf="!menuItem.hideInNavigation">
              <ng-container *ngTemplateOutlet="
                recursiveList;
                context: { $implicit: menuItem }
              "></ng-container>
              <div *ngIf="!last" class="dropdown-divider m-0"></div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
    <p *ngIf="
      level.activeMenuItem &&
      level.activeMenuItem.isActive &&
      level.menuItems.length < 2
    " [ngClass]="{ 'ps-3': !top }" [ngStyle]="{'color': getUserColor()}">
      {{ level.activeMenuItem.label }}
    </p>
    <a *ngIf="
      (!level.activeMenuItem || !level.activeMenuItem.isActive) &&
      level.menuItems.length < 2 &&
      level.menuItems.length
    " class="cursor-pointer" [ngStyle]="{'color': getUserColor()}" (click)="navigate($event, level.menuItems[0])"
      (auxclick)="navigate($event, level.menuItems[0], true)">
      {{ level.menuItems[0].label }}
    </a>
  </ng-container>


  <ng-template #modalcontent let-modal>
    <div>
      <div class="modal-header">
        <h5 class="modal-title">
          {{ 'choose-company' | label: 'company-selection' | async }}
        </h5>
        <button type="button" class="btn-close" aria-label="close" (click)="modal.dismiss()">
        </button>
      </div>
      <div class="modal-body" style="overflow: initial; max-height: initial;">
        <ul>
          <li *ngFor="let company of companies" (click)="modal.close(company.id)">
            <a>{{company.name}}</a>
          </li>
        </ul>
      </div>
    </div>
  </ng-template>
</div>